import React, { Component, Fragment } from 'react'
import { observer } from 'mobx-react'
import { Button, Modal } from 'hljd'
import { getMerchantInfo } from '@util'
import { LITE_APP_SELECT_PATH_A } from '@constant'
import { liteAppNotOpen } from '@components/LocalMerchant/LiteApp/util'

@observer
export default class extends Component {
  render() {
    const { visible, close, codeUrl, notOpen } = this.props.store
    const { logo_path } = getMerchantInfo()

    return (
      <Modal
        width={460}
        title={null}
        footer={null}
        visible={visible}
        onCancel={close}
      >
        <div>
          <h2 className="text-center" style={{ fontSize: 24, color: '#333' }}>
            店铺小程序码
          </h2>
          <p
            className="text-center"
            style={{ fontSize: 16, marginTop: 10, color: '#333' }}
          >
            请用微信扫描
          </p>

          <div>
            <div className="text-center" style={{ position: 'relative' }}>
              <img src={codeUrl} style={{ width: 168, height: 168 }} />

              {notOpen && (
                <img
                  src={`${logo_path}?imageView/1/w/70/h/70`}
                  style={{ borderRadius: '50%', filter: 'grayscale(50%)' }}
                  className="center"
                />
              )}
            </div>

            {liteAppNotOpen() ? (
              <div className="text-center">
                <Button
                  type="primary"
                  style={{ marginTop: 20 }}
                  onClick={() => window.open(LITE_APP_SELECT_PATH_A)}
                >
                  免费开通
                </Button>
              </div>
            ) : (
              <Fragment>
                <span>
                  小贴士：可以将小程序码，添加到公众号、图片、海报等宣传资料中，客户扫码即可获得服务
                </span>

                <a
                  href={codeUrl}
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{ marginLeft: 10 }}
                >
                  下载图片
                </a>
              </Fragment>
            )}
          </div>
        </div>
      </Modal>
    )
  }
}
